import { render, staticRenderFns } from "./IntegrationDetail.view.vue?vue&type=template&id=5cc22080&"
import script from "./IntegrationDetail.view.vue?vue&type=script&lang=js&"
export * from "./IntegrationDetail.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports